import React from 'react';
import { Button } from 'reactstrap';

const LOCATION_CATEGORIES = ['standard', 'test', 'warehouse', 'other'];

const PracticeLocationItem = ({ location, onEdit, onDelete, onBillingPatch }) => {
    const addressParts = [
        location.address,
        location.city,
        [location.stateProvince, location.postalCode].filter(Boolean).join(' '),
    ].filter(Boolean);
    const formattedAddress = addressParts.join(', ');

    const handleDelete = () => {
        if (window.confirm('Are you sure you want to delete this location?')) {
            onDelete(location.id);
        }
    };

    const handleCategoryChange = (e) => {
        onBillingPatch(location.id, { locationCategory: e.target.value });
    };

    const handleBillableToggle = (e) => {
        onBillingPatch(location.id, { isBillable: e.target.checked });
    };

    const handleClearOverride = () => {
        onBillingPatch(location.id, { clearOverride: true });
    };

    const billingDisabled = location.isDeleted || !!location.billingPending;

    const rowStyle = location.isDeleted
        ? { opacity: 0.5, fontStyle: 'italic' }
        : undefined;

    return (
        <>
            <tr style={rowStyle}>
                <td>{location.locationId}</td>
                <td>{location.name}</td>
                <td>{formattedAddress || '-'}</td>
                <td>
                    <select
                        value={location.locationCategory || ''}
                        onChange={handleCategoryChange}
                        disabled={billingDisabled}
                        aria-label={`Category for location ${location.locationId}`}
                        style={{ background: 'transparent', color: 'inherit', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '3px', padding: '1px 4px' }}
                    >
                        <option value="" style={{ color: '#212529', background: '#fff' }}>—</option>
                        {LOCATION_CATEGORIES.map((cat) => (
                            <option key={cat} value={cat} style={{ color: '#212529', background: '#fff' }}>
                                {cat}
                            </option>
                        ))}
                    </select>
                </td>
                <td>
                    <input
                        type="checkbox"
                        checked={location.isBillable === true}
                        onChange={handleBillableToggle}
                        disabled={billingDisabled}
                        aria-label={`Is billable for location ${location.locationId}`}
                    />
                </td>
                <td>
                    {location.isBillableOverridden && (
                        <>
                            <span
                                className="badge badge-warning"
                                title="Billable flag set explicitly by an operator; category changes will not reset it."
                                style={{ fontSize: '0.7rem' }}
                            >
                                operator-set
                            </span>
                            {!location.isDeleted && (
                                <Button
                                    color="link"
                                    size="sm"
                                    className="text-light ml-1 p-0"
                                    title="Clear operator override and revert to category default"
                                    onClick={handleClearOverride}
                                    disabled={billingDisabled}
                                    style={{ fontSize: '0.7rem', verticalAlign: 'baseline' }}
                                >
                                    Clear
                                </Button>
                            )}
                        </>
                    )}
                </td>
                <td>
                    {location.source && (
                        <span
                            className="badge badge-secondary"
                            style={{ fontSize: '0.7rem' }}
                        >
                            {location.source}
                        </span>
                    )}
                </td>
                <td>
                    {!location.isDeleted && (
                        <>
                            <Button
                                color="link"
                                size="sm"
                                className="text-light mr-2"
                                onClick={() => onEdit(location)}
                            >
                                Edit
                            </Button>
                            <Button
                                color="link"
                                size="sm"
                                className="text-danger"
                                onClick={handleDelete}
                            >
                                Delete
                            </Button>
                        </>
                    )}
                    {location.isDeleted && (
                        <span className="text-muted" style={{ fontSize: '0.75rem' }}>
                            deleted
                        </span>
                    )}
                </td>
            </tr>
            {location.billingError && (
                <tr style={rowStyle}>
                    <td colSpan={8} style={{ paddingTop: 0 }}>
                        <small className="text-danger" role="alert">
                            {location.locationId}: {location.billingError}
                        </small>
                    </td>
                </tr>
            )}
        </>
    );
};

export default PracticeLocationItem;
